/**
 * Контракты слоя отправки лид-форм. Реализация зависит от окружения
 * (console в dev, Telegram/Bitrix/Email — поставятся бэкенд-фазой).
 *
 * Спека: `design/03-design-system.md § 5.4`.
 *
 * С `types/`-рефакторинга сами типы живут в `@/types/types`; здесь —
 * обратно-совместимый реэкспорт и класс-маркер `NotImplementedError`
 * (это рантайм-значение, а не тип, поэтому в `types/` не помещается).
 */

export type {
  LeadSource,
  LeadPayload,
  SubmitErrorCode,
  SubmitError,
  SubmitResult,
  FormSubmitter,
} from '@/types/types';

export class NotImplementedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NotImplementedError';
  }
}
